/**
 * inline table handler
 * handles business_type='inline_table' messages (e.g. compare_formulations_json_docs).
 */

import type { AgentMessageResponse } from '@/types/formulation/formulation';
import type { StreamMessageHandler, StreamMessageData, HandlerContext } from '../types';

export const inlineTableHandler: StreamMessageHandler = {
  name: 'inline-table',

  canHandle(data: StreamMessageData): boolean {
    return data.business_type === 'inline_table';
  },

  handle(data: StreamMessageData, ctx: HandlerContext): boolean {
    // arrives complete; ignore any non-completed event.
    if (data.tool_state !== 'completed') return false;

    const { tool_key, content, id } = data;
    const { sessionIdValue, streamIteration, roundStartIso, deps } = ctx.streamContext;
    const { conversationData } = deps;

    const messageId = id ?? Date.now();
    const message: AgentMessageResponse = {
      id: messageId,
      clientKey: String(messageId),
      business_type: 'inline_table',
      session_id: sessionIdValue,
      iteration: streamIteration,
      tool_key,
      content: content as { raw?: unknown } | null,
      tool_state: 'completed',
      gmt_created: roundStartIso,
    };

    // upsert by id so a re-delivered message replaces rather than duplicates.
    const existing = conversationData.value ?? [];
    const idx = existing.findIndex((m) => m.id === messageId);
    if (idx >= 0) {
      const next = [...existing];
      next[idx] = message;
      conversationData.value = next;
    } else {
      conversationData.value = [...existing, message];
    }

    return false;
  },
};
